import { Box, Typography } from '@material-ui/core';
import { FunctionComponent, ReactNode } from 'react';
import passwordResetStyles from '../styles';

interface WrapperI {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

const Wrapper: FunctionComponent<WrapperI> = ({
  icon,
  title,
  subtitle,
  children
}: WrapperI) => {
  const classes = passwordResetStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <div className={classes.icon}>{icon}</div>
        <Typography className={classes.title}>{title}</Typography>
        {subtitle && (
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        )}
      </Box>
      {children}
    </Box>
  );
};

export default Wrapper;

Wrapper.defaultProps = {
  subtitle: undefined,
  children: undefined
};
